/**
 * Black Wave Homepage
 * Measures fixed header/footer heights and sets CSS custom properties
 * so the snap container and hero fill the remaining viewport.
 */
(function () {
  if (!document.body.classList.contains('template-index')) return;

  function measure() {
    var header = document.querySelector('.section-header');
    var footer = document.querySelector('.shopify-section-group-footer-group');
    var hH = header ? header.offsetHeight : 0;
    var fH = footer ? footer.offsetHeight : 0;
    document.documentElement.style.setProperty('--bw-header-h', hH + 'px');
    document.documentElement.style.setProperty('--bw-footer-h', fH + 'px');
  }

  measure();
  window.addEventListener('resize', measure);
  // Re-measure after fonts/images may have loaded
  window.addEventListener('load', measure);
})();
